import {CrudManager} from "@/scripts/ProfiControlRequests/CrudManager";
import {WebchargeSettingDto} from "@/model/WebchargeSettingDto";
import {WebchargeSetting} from "@/model/WebchargeSetting";

export class SettingRequester {

    public static getWebchargeSettings(url: string, token: string, config: WebchargeSetting, lang: string): void {
        CrudManager.Get<WebchargeSettingDto>(url, token, lang)
            .then(response => {
                config.setValues(response.data);
            }).catch(_ => {
            config.hasConfigurationError = true;
        });
    }

    public static updateWebchargeSettings(url: string, config: WebchargeSetting, token: string, lang: string): void {
        CrudManager.Put<WebchargeSettingDto>(url, config.getDtoForUpdate(), token, lang)
            .then(response => {
                config.setValues(response.data);
            }).catch(error => {
                if (error.response.status != 400)
                    return;
                config.hasConfigurationError = true;
                config.configurationErrors = error.response.data.errors;
            });
    }
}
